var path = '/templates/zenclerk_s/directives/dashboard/active_campaigns_widget.html';
var html = "<div><ul class=list><li ng-repeat=\"campaign in $ctrl.campaigns\"><div class=row><div class=col-xs-8>{{campaign.name}}<br><small>{{campaign.start_at | zcDate}} - {{campaign.end_at | zcDate}}</small></div><div class=\"col-xs-4 text-right\"></div></div></li><li class=text-center><zcs-campaign-create-button project=$ctrl.project></zcs-campaign-create-button></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/active_campaigns_widget.html
// module id = 1334
// module chunks = 0